<template>
  <div>
    <span v-if="fact">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span
            class="font-weight-bold"
            v-on="on"
          >{{ fact | date }}</span>
        </template>
        <span>{{ plan | date }}</span>
      </v-tooltip>
    </span>
    <span
      v-else
      class="grey--text"
    >
      {{ plan | date }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["plan", "fact"],
};
</script>
